<template lang="pug">
  .component-card-action-buttons(v-if="entity")
    .dropdown-buttons(v-if="actions.length")
      button.button(
        v-for="action in actions" :key="action.name"
        type="button", :class="action.severity"
        v-on:click="action.callback") {{action.name}}
    .dropdown-buttons(v-else)
      span No actions available
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"
  import CardSmartEdit from "../../../backoffice/smartedits/CardEdit.vue"
  import CardBind from "../../../backoffice/smartedits/CardBind.vue"

  export default {
    name: "CardActionButtons",
    components: {
      CardSmartEdit,
    },
    data() {
      return {
        entity: null,
      }
    },
    created() {
      if (!this.card) {
        KeplerBackofficeSdk.cards.select(this.$route.params.id).get((item) => {
          this.entity = item
        })

      } else {
        this.entity = this.card
      }
    },
    computed: {
      actions() {
        const arr = []
        const aclArr = [
          {
            acl: this.$acl('edit-cards'),
            name: 'Edit',
            callback: this.edit,
            severity: 'success'
          },
          {
            acl: this.$acl('unbind-card-cards'),
            name: 'Unbind',
            callback: this.unbind,
            severity: 'warning'
          },
          {
            acl: this.$acl('edit-cards'),
            name: 'Bind',
            callback: this.bind,
            severity: 'warning'
          },
          {
            acl: this.$acl('delete-cards'),
            name: 'Delete',
            callback: this.remove,
            severity: 'alert'
          }
        ]
        for (const actn of aclArr) {
          const bound = this.card.driver
          if (actn.name === 'Unbind' && !bound) {
            continue
          }
          if (actn.name === 'Bind' && bound) {
            continue
          }
          if (actn.acl) {
            delete actn.acl
            arr.push(actn)
          }
        }
        return arr
      },
    },
    methods: {
      edit() {
        MaggieHelper.openRightPanel({
          component: CardSmartEdit, props: {
            item: this.entity
          }
        })
      },
      bind() {
        MaggieHelper.openRightPanel({
          component: CardBind, props: {
            item: this.entity
          }
        })
      },
      unbind() {
        this.$confirm('Are you sure?', 'Do you really want to unbind this card from its driver?', () => {
          KeplerBackofficeSdk.cards.select(this.entity).unbind((response) => {
            MaggieHelper.notification('unbind-esit', "Card disconnected")
            location.reload()
          })
        })
      },
      remove() {
        this.$confirm('Are you sure?', 'Do you really want to delete this card?', () => {
          KeplerBackofficeSdk.cards.select(this.entity).remove((response) => {
            MaggieHelper.notification('remove-esit', "Card deleted")
          })
        })
      },
    },
    props: ['card', 'item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CardActionButtons.vue?4d2e7b7a